/** Single source of truth for this site's identity (per-repo). */
export const SITE = {
  name: 'Caudexology',
  origin: 'https://caudexology.com',
  tagline: 'Caudex & Succulent Care',
  description:
    'Science-based care guides for caudex and succulent plants — pachypodium, adenium, dioscorea, and more.',
  knowsAbout: [
    'Caudex plants',
    'Succulents',
    'Pachypodium',
    'Adenium',
    'Caudiciforms',
    'Plant care',
  ],
} as const

export const APP_NAME = SITE.name
export const BASE_URL =
  (import.meta as ImportMeta & { env: Record<string, string> }).env['VITE_BASE_URL'] ?? '/'
